module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"ma-ni-to","short_name":"starter","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/Untitled(endMini).svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"9239a299d0c62b4fc1c0a06f637c9650"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
